import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  output
} from '@angular/core';
import {
  BD_STATES_REAL,
  BdState,
  BdStateStore,
} from '@bindoc-projects/geographic-domain-lib';
import {
  BD_MAPS_STATE_SELECT_OPTIONS_DEFAULT,
  BdMapsStateSelectOptions,
} from '../../select-options';
import { BdUiSingleSelectComponent, BdUiSingleSelectConfig } from '@bindoc-projects/ui-lib/selection/ui';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'bd-maps-state-select-inline-single',
  template: `
    <bd-ui-single-select
      [config]="selectConfig"
      [selectOptions]="stateOptions()"
      [initialSelection]="initialState()"
      (selection)="stateSelect.emit($event)"
    ></bd-ui-single-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BdUiSingleSelectComponent],
})
export class BdMapsStateSelectInlineSingleComponent {
  readonly states = input<BdState[]>(BD_STATES_REAL);
  readonly initialStateId = input<number>();
  readonly options = input<BdMapsStateSelectOptions>(BD_MAPS_STATE_SELECT_OPTIONS_DEFAULT);

  readonly stateSelect = output<BdState | null>();

  public readonly selectConfig: BdUiSingleSelectConfig<BdState> = {
    id: 'maps-state-select-inline-single',
    selectLabel: 'Bundesland auswählen',
    option: {
      uniqueFnc: (option) => option.id.toString(),
      searchOptionAccessor: (option) => option.name,
      sortFnc: (a, b) => a.name.localeCompare(b.name),
    },
    resetOption: false,
  };

  readonly stateOptions = computed<Observable<BdState[]>>(() => of(this.states()));

  readonly initialState = computed<BdState | undefined>(() => {
    const id = this.initialStateId();
    return id !== undefined ? BdStateStore.byId(id) : undefined;
  });

  constructor() {
    effect(() => {
      this.selectConfig.resetOption = this.options().resetOption;
    });
  }
}
